import { ECurrency, ECurrencySymbolPosition } from '../constants/currencies'

export const CurrenciesMap = {
	[ECurrency.PLN]: {
		label: 'Polish Zloty',
		iso: 'PLN',
		symbol: 'PLN\u00A0',
		position: ECurrencySymbolPosition.BACK,
	},
	[ECurrency.EUR]: {
		label: 'Euro',
		iso: 'EUR',
		symbol: '€',
		position: ECurrencySymbolPosition.FRONT,
	},
	[ECurrency.GBP]: {
		label: 'British Pound',
		iso: 'GBP',
		symbol: '£',
		position: ECurrencySymbolPosition.FRONT,
	},
	[ECurrency.USD]: {
		label: 'US Dollar',
		iso: 'USD',
		symbol: '$',
		position: ECurrencySymbolPosition.FRONT,
	},
	[ECurrency.CZK]: {
		label: 'Czech Koruna',
		iso: 'CZK',
		symbol: 'CZK\u00A0',
		position: ECurrencySymbolPosition.BACK,
	},
	[ECurrency.HUF]: {
		label: 'Hungarian Forint',
		iso: 'HUF',
		symbol: 'HUF\u00A0',
		position: ECurrencySymbolPosition.BACK,
	},
	[ECurrency.RON]: {
		label: 'Romanian Leu',
		iso: 'RON',
		symbol: 'RON\u00A0',
		position: ECurrencySymbolPosition.BACK,
	},
	[ECurrency.SEK]: {
		label: 'Swedish Krona',
		iso: 'SEK',
		symbol: 'SEK\u00A0',
		position: ECurrencySymbolPosition.BACK,
	},
	[ECurrency.DKK]: {
		label: 'Danish Krone',
		iso: 'DKK',
		symbol: 'DKK\u00A0',
		position: ECurrencySymbolPosition.BACK,
	},
	[ECurrency.NOK]: {
		label: 'Norwegian Krone',
		iso: 'NOK',
		symbol: 'NOK\u00A0',
		position: ECurrencySymbolPosition.BACK,
	},
}

export const availableCurrenciesArray = [ECurrency.PLN, ECurrency.EUR, ECurrency.GBP, ECurrency.USD]
